<div #componentRootRef>
  @if (notificationList.length) {
    <div class="top-notif-container">
      @for (item of notificationList; track item.id; let i = $index) {
        <div>
          <mc-notification-card
            [@fadeInOut]="getFadeInOutState(i)"
            [@slideIn]="getSlideInState(i)"
            class="top-notif__item"
            [class.current]="i === currentIndex"
            [severity]="getSeverity(item, userInfo.trialInfo())"
            (click)="openNotificationsDrawer(item)"
          >
            @if (isGeneralAnnouncement(item)) {
              <div class="container">
                <mat-icon>notifications_none</mat-icon>
                <span class="notification-inner-text" [innerHTML]="item.htmlContent"></span>
              </div>
            }
            @if (isUserNotification(item)) {
              <div class="container">
                @if (item.source === notificationSource.AccountBillingAlerts) {
                  @if (isTrialNoCardNotification(item, userInfo.trialInfo())) {
                    <mat-icon svgIcon="info-border" color="primary"></mat-icon>
                  } @else {
                    <mat-icon svgIcon="credit_card"></mat-icon>
                  }
                }

                <span class="notification-inner-text" [ngClass]="{'trial-no-card': shouldShowUpgradeBtn(item)}">
                  <span [innerHTML]="getNotificationText(item, userInfo.trialInfo())"></span>
                  <span>
                    @if (shouldShowUpgradeBtn(item)) {
                      <span class="upgrade-now">
                        <mc-notification-link
                          (linkClick)="showPaymentForm()"
                          content="Upgrade now"
                        ></mc-notification-link>
                        <mat-icon svgIcon="arrow-blue" color="primary" class="upgrade-now-icon"></mat-icon
                      ></span>
                    }
                    @if (item.type === notificationType.AccountBillingAlertsPaymentFailed) {
                      <mc-notification-link
                        (linkClick)="goToBillingSetting($event, item.id)"
                        content="Please update your payment method."
                      ></mc-notification-link>
                    }
                    @if (
                      item.type === notificationType.AccountBillingAlertsPaymentMethodExpires &&
                      NotificationsService.getNumberOfDaysToExpire(item) < 1
                    ) {
                      <mc-notification-link
                        (linkClick)="goToBillingSetting($event, item.id)"
                        content="Update your payment information to avoid any service disruptions."
                      ></mc-notification-link>
                    }
                    {{ NotificationsService.getDetailsTextNotification(item) }}

                    @if (
                      item.type === notificationType.AccountBillingAlertsPaymentMethodExpires &&
                      NotificationsService.getNumberOfDaysToExpire(item) >= 1
                    ) {
                      <mc-notification-link
                        (linkClick)="goToBillingSetting($event, item.id)"
                        content="Please update your payment method."
                      ></mc-notification-link>
                    }
                  </span>
                </span>
              </div>
            }
          </mc-notification-card>
        </div>
      }
    </div>
  }
</div>
